<div class="error-page" fxLayout="column" fxLayoutAlign="center center">
  <mat-icon svgIcon="error_outline"></mat-icon>
  <div class="title">{{ 'MAIN.ERROR_PAGE_TITLE' | translate }}</div>
  <div class="description">{{ 'MAIN.ERROR_PAGE_DESCRIPTION' | translate }}</div>
</div>
